// Various functions for dealing with math operators in CanvasMath, used by both parsing and rendering.

const {escapeRegex} = require("../../../shared/StringUtil");

const list = ["+", "-", "*", "/", "=", "<", ">", "\\approx", "\\neq"];
// cdot is also an operator, but "\\cdot" does not appear in the list
// as that would keep cdots from being able to be a command. It is instead
// in the list of math commands and always non-unary.

// Regexp pattern fragment that matches any operator, suitable to
// pass to the RegExp constructor.
const patternFragment = list.map(x => escapeRegex(x)).join("|");

// Compute the actual symbol to draw for an operator node.
const computeText = function(text, node) {
	const isUnary = !!(node && node.isUnary);
	if (text === "*") {
		return "\u00D7";
	} else if (text === "/") {
		return "\u00F7";
	} else if (text === "-" && !isUnary) {
		return "\u2212";
	} else if (text === "\\approx") {
		return "\u2248";
	} else if (text === "\\neq") {
		return "\u2260";
	} else if (text === "\\cdot") {
		return "\u2022";
	} else {
		return text;
	}
};

// Returns true if the text sliced up to the given position is
// probably the beginning of a new expression. Otherwise, returns false.
const isNextUnary = function(text, pos) {
	text = text.slice(0, pos).trim();
	const lastChar = text.length ? text[text.length - 1] : "";
	if (!lastChar) {
		return true;
	} else if (/[0-9A-Za-z!\%]/.test(lastChar)) {
		return false;
	} else if (/[\(\[\{]/.test(lastChar)) {
		return true;
	} else if (/[\)\]\}]/.test(lastChar)) {
		return false;
	} else {
		return true;
	}
};

module.exports = {
	list,
	patternFragment,
	computeText,
	isNextUnary,
};
